import { jsx as e, jsxs as p } from "react/jsx-runtime";
import c from "./box.js";
import { Boxed as g } from "./boxed.js";
import { useScreenSize as u, useTheme as y } from "./hooks.js";
import d from "./stack.js";
import { Text as E, Text2 as N } from "./text.js";
import T from "./button-group.js";
import { container as B, iconContainer as C, image as k } from "./empty-state-card.css-mistica.js";
import { vars as v } from "./skins/skin-contract.css-mistica.js";
const z = (param)=>{
    let { title: n , description: h , button: r , secondaryButton: i , buttonLink: t , icon: o , imageUrl: a , "aria-label": f , dataAttributes: x  } = param;
    var s;
    const { isTabletOrSmaller: l  } = u(), { textPresets: S  } = y();
    let m;
    return a && (m = /* @__PURE__ */ e("img", {
        className: k,
        alt: "",
        src: a
    })), process.env.NODE_ENV !== "production" && r && !((s = r == null ? void 0 : r.props) != null && s.small) && console.error("button property in EmptyStateCard must be a a small Button. Set small prop to true"), /* @__PURE__ */ e(g, {
        dataAttributes: x,
        children: /* @__PURE__ */ e(c, {
            paddingY: l ? 24 : 40,
            paddingX: l ? 16 : 40,
            children: /* @__PURE__ */ e("section", {
                className: B,
                "aria-label": f,
                children: /* @__PURE__ */ p(d, {
                    space: 16,
                    children: [
                        m !== null && m !== void 0 ? m : o && /* @__PURE__ */ e("div", {
                            className: C,
                            children: o
                        }),
                        /* @__PURE__ */ e(c, {
                            children: /* @__PURE__ */ p(d, {
                                space: 8,
                                children: [
                                    /* @__PURE__ */ e(E, {
                                        mobileSize: 18,
                                        mobileLineHeight: "24px",
                                        desktopSize: 20,
                                        desktopLineHeight: "28px",
                                        weight: S.cardTitle.weight,
                                        children: n
                                    }),
                                    /* @__PURE__ */ e(N, {
                                        regular: !0,
                                        color: v.colors.textSecondary,
                                        children: h
                                    })
                                ]
                            })
                        }),
                        (r || i || t) && /* @__PURE__ */ e(T, {
                            primaryButton: r,
                            secondaryButton: i,
                            link: t
                        })
                    ]
                })
            })
        })
    });
}, V = z;
export { V as default };
